// Third-party partner links + affiliate/referral IDs.
//
// Keep this file as the single source of truth for any external referral
// URL that appears in the UI — makes it trivial to swap or A/B test.
//
// Attribution note: any customer signing up via these links must click the
// link BEFORE they start their Workspace trial. There is NO retroactive
// tracking — this is a Google requirement (see FAQ). Every CTA in the app
// that points at Workspace must go through GOOGLE_WORKSPACE_REFERRAL_URL,
// never directly to workspace.google.com.

export const GOOGLE_WORKSPACE_REFERRAL_URL =
  "https://c.gle/AOPyDKTNCrU59jtEcqEaTUu4uKW1V61uDNI6VhxFluGm-EaiIDuj_kExFIhi6kSymf5AIz1dizWYQBW9zOPqmeiiUHx-Hr_cGktdcfeo5BuGwnlwVnAzl-zPQLgrxeCicA_22E5Txffv1JylNUyj_NPT";

// Optional 10% off first-year promo code (Google issues these on request —
// see FAQ "Promotion Codes"). Leave empty until issued.
export const GOOGLE_WORKSPACE_PROMO_CODE = "";

// Emits a GA4 event when the user clicks a Workspace referral link.
// Called from every Workspace CTA so we can measure funnel volume even
// though Google's own conversion tracking happens outside our app.
export function trackWorkspaceReferralClick(source) {
  if (typeof window === "undefined" || !window.gtag) return;
  try {
    window.gtag("event", "workspace_referral_click", {
      referral_source: source, // "dashboard-banner" | "upgrade-page" | "footer" | etc.
      partner: "google_workspace",
    });
  } catch (_) { /* analytics must never break UX */ }
}
